var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bill',{attrs:{"menuId":_vm.page.id,"options":_vm.getOptions(),"queryConditionPaneComponent":_vm.getQueryConditionPane(),"queryResultWorker":_vm.getQueryResultWorker(),"editorComponent":_vm.getEditorComponent(),"queryResultKeyInfo":_vm.getQueryResultKeyInfo(),"emptyRec":_vm.getEmptyRec()}})
}
var staticRenderFns = []

export { render, staticRenderFns }